import { render } from "./App.vue?vue&type=template&id=388452c4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=388452c4&lang=css"

import exportComponent from "D:\\JotaDev\\Vue\\VueMastery\\Real-World_Vue-3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__